import React from 'react'
import { Link } from 'react-router-dom';
import { getSiteId } from '../../Utils/helper';
import { BASE_URL } from '../../constants';

const Checkout = () => {

    const bannerStyle = {
        backgroundImage: `url(${BASE_URL}/assets/images/bienvenidBg.png)`,
      };

  return (
    <div>
        <Link to={`/${getSiteId()}/`}>
        <div className="wrapper">
        <div className="bannerArea bienvenidaBnrArea" style={bannerStyle}>
           <div className="container">
                <div className="heading">
                    <h2>¡Te damos la bienvenida <br/> <span style={{textTransform: 'capitalize'}}>{JSON.parse((localStorage.getItem('bookingData'))).name}</span>!</h2>
                </div>
                <div className="itemBox">
                    
                        <div className="subText">
                             <div className='fairy_red_icn'><img src={`${BASE_URL}/assets/images/fairy_red.png`} alt="" /></div>
                            <span>Gracias por compartirnos tu orden. Les deseamos que tengan <strong>una gran experiencia. </strong> En un momento podrás pasar con uno de nuestros anfitriones, quien te llevará a tu mesa asignada.</span>
                            <div className='fairy_blue_icn'><img src={`${BASE_URL}/assets/images/fairy_blue.png`} alt="" /></div>
                            <div className='fairy_green_icn'><img src={`${BASE_URL}/assets/images/fairy_green.png`} alt="" /></div>
                        </div>
                       
                </div>
                {/* <div className="image">
                    <img src={`${BASE_URL}/assets/images/dumbo.png`} alt="" />
                </div> */}

                <div className="logo">
                <img src={`${BASE_URL}/assets/images/logo.png`} alt="" />
                </div>
                {/* <div>
                    <Link to={`/${getSiteId()}/`} className="btn visitaBtn">Disfruta tu vísita</Link>
                </div> */}
           </div>
        </div>
    </div>
    </Link>
    </div>
  )
}

export default Checkout